import React from 'react';
import styles from './Wrapper.module.scss';
import { AppContextProvider } from '../context/AppContext';

interface WrapperProps {
  children: React.ReactNode;
  serverUrl: string;
  stage: string;
  locale: string;
}

export const Wrapper = ({ children, serverUrl, stage, locale }: WrapperProps) => {
  return (
    <AppContextProvider serverUrl={serverUrl} stage={stage} locale={locale}>
      <div className={styles.root}>{children}</div>
    </AppContextProvider>
  );
};
